import * as Sentry from '@sentry/react'

/**
 * Centralized helper for non-fatal errors we don't want to swallow silently.
 *
 * Use this instead of `.catch(() => {})` when a failure shouldn't crash the
 * page but you still want a debug trail. It logs to the browser console (so
 * the user can paste it into a support ticket) and forwards to Sentry with
 * the provided tag so we can group similar failures in production.
 *
 * Genuine "fire-and-forget" calls that degrade gracefully (e.g. preloading
 * Google Maps, optional analytics) can keep their silent catches — this
 * helper is for code paths where the user might say "it didn't save" or
 * "the button didn't do anything".
 *
 * @param {string} tag — short stable identifier ("account.billing-portal").
 * @param {unknown} err — the caught error.
 * @param {Record<string, unknown>} [extra] — optional context attached to Sentry.
 */
export function logError(tag, err, extra) {
   
  console.error(`[${tag}]`, err, extra || '')
  try {
    Sentry.captureException(err, {
      tags: { source: tag },
      extra,
    })
  } catch {
    // If Sentry isn't initialized (tests, dev without DSN), ignore — the
    // console.error above still gives a debug trail.
  }
}
